import { DeleteForever, Edit } from '@mui/icons-material'
import React from 'react'
import CustomIconButton from "../../CustomTooltipIconButton"

const buildActions = (value) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
      <CustomIconButton
        onClick={value.edit}
        tooltipTitle="Editar registro"
        icon={<Edit />}
      />

      <CustomIconButton
        onClick={value.remove}
        tooltipTitle="Remover registro"
        icon={<DeleteForever />}
      />
    </div>
  )
}

export const columns = [
  {
    name: 'section',
    label: 'Seção',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'denomination',
    label: 'Denominação',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'group_name',
    label: 'Nome do grupo',
    options: {
      filter: false,
      sort: false,
    },
  },

  {
    name: 'group_number',
    label: 'Número do grupo',
    options: {
      filter: false,
      sort: false,
    },
  },

  {
    name: 'division_name',
    label: 'Nome da divisão',
    options: {
      filter: false,
      sort: false,
    },
  },

  {
    name: 'division_number',
    label: 'Número da divisão',
    options: {
      filter: false,
      sort: false,
    },
  },

  {
    name: 'class_name',
    label: 'Nome da classe',
    options: {
      filter: false,
      sort: false,
    },
  },

  {
    name: 'subclass',
    label: 'Subclasse',
    options: {
      filter: false,
      sort: false,
    },
  },

  {
    name: 'treated_subclass',
    label: 'Subclasse tratada',
    options: {
      filter: false,
      sort: false,
    },
  },

  {
    name: 'subclass_denomination',
    label: 'Denominação da subclasse',
    options: {
      filter: false,
      sort: false,
    },
  },

  {
    name: 'classification',
    label: 'Classificação',
    options: {
      filter: false,
      sort: false,
    },
  },

  {
    name: 'observation',
    label: 'Observação',
    options: {
      filter: false,
      sort: false,
    },
  },

  {
    name: 'actions',
    label: 'Ações',
    options: {
      filter: false,
      sort: false,
      download: false,
      customBodyRender: (value) => buildActions(value),
      setCellProps: () => ({
        style: {
          width: '100px',
        },
      }),
    },
  },
]
